import React, { useContext } from 'react';

export const Context = React.createContext({});

export const contextConnect = () => (WrappedComponent) =>
    // eslint-disable-next-line react/display-name
    (props) => {
        const context = useContext(Context);

        return (
            <WrappedComponent {...props} {...context}/>
        );
    };
